<template>
  <div class="modal-horas">
    <div class="modal-horas-bg">
      <div class="modal-horas-content rounded p-4">
        <div class="row" v-if="true">
          <div class="col-md-4">
            <div class="label mb-2">
              <strong>{{ item.dia }} de {{ item.mes }}</strong> {{ item.ano }}
            </div>
            <p class="mb-2">Escolha o intervalo de horas:</p>
            <FormulateForm name="agenda" v-model="values" @submit="salvar">
              <FormulateInput
                type="time"
                label="INÍCIO"
                name="horaInicio"
                validation="required"
                @input="validarHora()"
              />
              <FormulateInput
                type="time"
                label="ENCERRAMENTO"
                name="horaFim"
                validation="required"
                @input="validarHora()"
              />
            </FormulateForm>
            <div class="alert alert-danger" v-if="agendaErro">
              Intervalo inválido.
            </div>
          </div>
          <div class="col-md-8 mt-3 mt-md-0">
            <p class="mb-3"><strong>Horários reservados</strong></p>
            <div v-if="loading">
              <loading />
            </div>
            <ul class="list-group" v-else-if="listaHoras.length">
              <li
                class="list-group-item"
                v-for="(hora, index) in listaHoras"
                :key="index"
              >
                {{ hora }}
              </li>
            </ul>
            <div v-else>Todos os horários disponíveis!</div>
          </div>
        </div>
        <div v-else>
          <div class="label mb-2">
            <strong>{{ item.dia }} de {{ item.mes }}</strong> {{ item.ano }}
          </div>
          <div
            class="horario-reservado bg-white rounded px-4 py-5 d-flex flex-column justify-content-md-center align-items-center"
          >
            <button type="button" class="btn btn-icon">
              <span class="material-icons text-muted"> delete_outline </span>
            </button>
            <div><strong class="text-muted">Seu horário reservado</strong></div>
            <div class="mt-2 lead">{{ isSave }}</div>
          </div>
        </div>
        <div class="row mt-5 flex-column-reverse flex-md-row">
          <div class="col-12 px-3">
            <div class="alert alert-warning" v-if="tipoReserva == 'rooftop'">
              * Mínimo de 4 horas da reserva<br />
              * Hora adicional: R$ {{ valorHora }}
            </div>
            <div class="alert alert-warning" v-else>
              * Hora adicional: R$ {{ valorHora }}
            </div>
          </div>

          <div class="col-md-6 mt-3 mt-md-0" :class="{ 'ml-auto': isSave }">
            <Botao
              title="Cancelar"
              nameClass="btn btn-outline-secondary btn-block"
              @click="cancelar()"
              >{{ isSave ? "FECHAR" : "CANCELAR" }}</Botao
            >
          </div>
          <div class="col-md-6">
            <Botao
              title="Salvar"
              nameClass="btn btn-cta btn-block font-weight-bold"
              @click="validar()"
              >SALVAR</Botao
            >
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Botao from "@/components/botoes/Botao.vue";

export default {
  name: "ModalHoras",
  components: {
    Botao,
  },
  props: {
    timeline: {
      type: Array,
      default: () => [8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22],
    },
    item: {
      type: Object,
      default: () => {},
    },
    isSave: {
      type: Object,
      default: () => {},
    },
    horas: {
      type: Array,
      default: () => [],
    },
    loading: {
      type: Boolean,
      default: true,
    },
    tipoReserva: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      select: [],
      agendaErro: false,
      values: {},
      agendaInvalida: false,
      valorHora: 0,
    };
  },
  computed: {
    listaHoras() {
      var horasReservadas = [];
      this.horas.forEach((agenda) => {
        const dateInicio = new Date(agenda.inicio);
        const dateFim = new Date(agenda.fim);

        horasReservadas.push(
          dateInicio.getHours() +
            ":" +
            ("0" + dateInicio.getMinutes()).slice(-2) +
            " - " +
            dateFim.getHours() +
            ":" +
            ("0" + dateFim.getMinutes()).slice(-2)
        );
      });
      return horasReservadas;
    },
  },
  methods: {
    validar() {
      if (!this.agendaInvalida) {
        this.$formulate.submit("agenda");
      }
    },
    salvar() {
      this.$emit("click", {
        horarios: this.values,
      });
    },
    cancelar() {
      this.$emit("cancelar");
    },
    validarHora() {
      this.$formulate.handle({ inputErrors: { horaInicio: null } }, "agenda");
      this.$formulate.handle({ inputErrors: { horaFim: null } }, "agenda");
      this.agendaInvalida = false;

      if (this.values.horaInicio && this.values.horaFim) {
        const horaInicio = new Date(
          this.item.date + "T" + this.values.horaInicio
        );
        const horaFim = new Date(this.item.date + "T" + this.values.horaFim);
        this.horas.forEach((hora) => {
          const reservaInicio = new Date(hora.inicio);
          // Valida o intervalo entre as duas horas se existe alguma reserva
          if (
            horaInicio.valueOf() < reservaInicio.valueOf() &&
            horaFim.valueOf() > reservaInicio.valueOf()
          ) {
            this.$formulate.handle(
              {
                inputErrors: { horaFim: "Horário reservada!" },
                hasErrors: { horaFim: true },
              },
              "agenda"
            );
            this.agendaInvalida = true;
          }
        });

        if (horaInicio.valueOf() >= horaFim.valueOf()) {
          this.$formulate.handle(
            {
              inputErrors: { horaFim: "Horário inválido maior inicio!" },
              hasErrors: { horaFim: true },
            },
            "agenda"
          );
          this.agendaInvalida = true;
        }

        if (this.tipoReserva == "rooftop") {
          const difHorario = horaFim.valueOf() - horaInicio.valueOf();
          if (difHorario / 60 / 60 < 4000) {
            this.$formulate.handle(
              {
                inputErrors: {
                  horaFim: "Reserva mínima é inferior a 4 horas!",
                },
                hasErrors: { horaFim: true },
              },
              "agenda"
            );
            this.agendaInvalida = true;
          }
        }
      }

      if (this.values.horaInicio) {
        const horaInicio = new Date(
          this.item.date + "T" + this.values.horaInicio
        );

        const horaAgora = new Date();
        if (horaInicio.valueOf() < horaAgora.valueOf()) {
          this.$formulate.handle(
            {
              inputErrors: { horaInicio: "Hora inválida!" },
              hasErrors: { horaInicio: true },
            },
            "agenda"
          );
        }

        this.horas.forEach((hora) => {
          const reservaInicio = new Date(hora.inicio);
          const reservaFim = new Date(hora.fim);
          if (
            reservaInicio.valueOf() <= horaInicio.valueOf() &&
            horaInicio.valueOf() < reservaFim.valueOf()
          ) {
            this.$formulate.handle(
              {
                inputErrors: { horaFim: "Horário reservada!" },
                hasErrors: { horaFim: true },
              },
              "agenda"
            );
            this.agendaInvalida = true;
          }
        });
      }

      if (this.values.horaFim) {
        const horaFim = new Date(this.item.date + "T" + this.values.horaFim);

        this.horas.forEach((hora) => {
          const reservaInicio = new Date(hora.inicio);
          const reservaFim = new Date(hora.fim);
          if (
            reservaFim.valueOf() >= horaFim.valueOf() &&
            horaFim.valueOf() > reservaInicio.valueOf()
          ) {
            this.$formulate.handle(
              {
                inputErrors: { horaFim: "Horário reservada!" },
                hasErrors: { horaFim: true },
              },
              "agenda"
            );
            this.agendaInvalida = true;
          }
        });
      }
      /*this.horas.forEach((hora) => {
        const reservaInicio = new Date(hora.horaInicio);
        const reservFim = new Date(hora.horaFim);
      });*/
    },
  },
  created() {
    if (this.isSave.horaInicio && this.isSave.horaFim) {
      this.values = this.isSave;
    }
    if (this.item.diaSemana === "sab" || this.item.diaSemana === "dom") {
      this.valorHora = "330,00";
    } else {
      this.valorHora = "150,00";
    }
  },
};
</script>
<style lang="scss" scoped>
strong {
  font-weight: 700;
}
.modal-horas /deep/ {
  @import "../../../node_modules/@braid/vue-formulate/themes/snow/snow.scss";
  .horario-reservado {
    position: relative;
    .btn-icon {
      position: absolute;
      right: 0;
      top: 0;
    }
  }
  .formulate-input-element {
    input {
      background-color: white !important;
    }
  }
  .modal-horas-bg {
    z-index: 99998;
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: rgba(0, 0, 0, 0.9);
  }
  .modal-horas-content {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    max-width: 690px;
    width: 100%;
    background: #e3e6f0;
    z-index: 99999;
    overflow-y: auto;
    max-height: 100vh;
  }
}
.lead {
  font-size: 2rem;
}
.list-group {
  height: 270px;
  overflow-y: auto;
  .list-group-item {
    font-size: 1.4rem;
    text-align: center;
  }
  @media screen and (max-width: 768px) {
    height: auto;
  }
}
.label {
  font-weight: 300;
  font-size: 16px;
  margin-bottom: 5px;
  line-height: 1.4;
}
.value {
  font-weight: bold;
  font-size: 16px;
  text-transform: uppercase;
  color: #000;
  line-height: 1.4;
}
.dia {
  width: 60px;
  height: 62px;
}
</style>
